import React from 'react';
import Button from '@components/Button';
import Warning from '@assets/warning.svg';
import styles from './index.module.scss';

const Error = ({ title }: { title?: string }) => {
  return (
    <div className={styles['error-container']}>
      <img className={styles['icon']} src={Warning} />
      <div>{title || `您访问的页面出错了`}</div>
      <Button
        className={styles['btn']}
        onClick={() => {
          window.location.reload();
        }}
      >
        刷新
      </Button>
    </div>
  );
};

export default Error;
